const isProd = process.env.REACT_APP_STAGE === "production";

let url;

isProd
  ? (url = "https://us-central1-bancoazteca-middleware.cloudfunctions.net")
  : (url = "http://localhost:5000/bancoazteca-middleware/us-central1");

export default url;
